import type { FC, ReactNode } from 'react';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { VerifiedName } from '@/features/posts/components/VerifiedName';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

type Props = {
  displayName?: string;
  isOrganizationPost: boolean;
  subTitle: ReactNode;
};

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    text: { color: theme.colors.onSurface }
  });

/**
 * Title used by the post-detail nav header: name (+ red verified badge for
 * organization posts) with a subtitle line underneath. Passed to
 * NavigationBar via its `titleComponent` slot because the default title
 * only accepts a plain string.
 */
export const PostDetailHeaderTitle: FC<Props> = ({
  displayName,
  isOrganizationPost,
  subTitle
}) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View>
      <VerifiedName
        variant="titleMedium"
        textStyle={styles.text}
        numberOfLines={1}
        name={displayName}
        verified={isOrganizationPost}
      />
      <Text variant="bodyMedium" style={styles.text}>
        {subTitle}
      </Text>
    </View>
  );
};
